export default __webpack_public_path__ + "static/media/breathing-shadow.ad99013b.svg";